import { serviceApi } from '@infrastructure/api';
import { apiResponseToFormData } from '../models/service.schema';
export const serviceRepository = {
    async getAll(params) {
        const response = await serviceApi.getAllServices(params);
        return response.data;
    },
    async getById(id) {
        const response = await serviceApi.getService(id);
        return response.data;
    },
    /**
     * Create a new service.
     * Note: With new API, schedule/availability is set separately via
     * PUT /services/:id/calendar/availability after service creation.
     * Calendar is auto-created when service is created.
     */
    async create(data) {
        const payload = {
            ...data,
        };
        // New API: Do not include schedule - it's set separately after service creation
        const response = await serviceApi.saveService(payload);
        return response.data;
    },
    async update(id, data) {
        const response = await serviceApi.updateService(id, data);
        return response.data;
    },
    async delete(id) {
        await serviceApi.deleteService(id);
    },
};
export function toFormData(service) {
    return apiResponseToFormData(service);
}
export default serviceRepository;
